import React from 'react';
import { SectionGroup } from 'components/storefront/editor/easyblocks-page/components';
import { replaceProps } from './utils';

/** @typedef {import('components/storefront/editor/easyblocks-page/asset-loader').default} AssetLoader */

/**
 * @param {AssetLoader} assetLoader
 */
function processLayoutGroupSections(assetLoader) {
  return {
    // Replace layout group sections with the actual components
    shouldProcessNode: function (node) {
      return node?.attribs?.id?.startsWith('swell-section-group');
    },
    processNode: function (node, children, index) {
      assetLoader.onContentRenderStart();

      replaceProps(node);

      return React.createElement(
        SectionGroup,
        {
          ...node.attribs,
          key: index,
        },
        children,
      );
    },
  };
}

export default processLayoutGroupSections;
